import $ from "jquery";

import * as FilePond from "filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import "filepond/dist/filepond.css"; // Импортируйте стили FilePond
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css"; // Импортируйте стили
import Toastify from "toastify-js";

FilePond.registerPlugin(FilePondPluginImagePreview);
FilePond.registerPlugin(FilePondPluginFileValidateSize);

const previewFiles = FilePond.create(document.querySelector("#review_files"), {
  name: "files[]", // Имя поля, которое будет использоваться на сервере для файлов
  credits: false,
  maxFiles: 10,
  allowMultiple: true,
  acceptedFileTypes: ["image/*"],
  maxFileSize: "5MB",
  imagePreviewHeight: 170,
  imageCropAspectRatio: 1,
  allowImagePreview: true,
  labelIdle:
    'Перетащите ваши файлы в поле или <span class="filepond--label-action"> выберите файлы вручную </span>',
  labelMaxFileSizeExceeded: "Файл больше 5МБ",
  labelMaxFileSize: "Максимальный размер файла это: {filesize}",
  itemInsertLocation: "after",
});

$(".review-file-trigger").on("click", function () {
  previewFiles.browse(); // 🔥 открывает системное окно выбора файла
});

$(".review__reset-form").on("click", function (e) {
  e.preventDefault();

  const form = $("#review-modal-form")[0];

  // Сброс обычных полей формы
  form.reset();

  // Очистка FilePond
  previewFiles.removeFiles();

  // Если есть кастомные ошибки / подсветки — тут же чистим
});


$(".send__review").on("click", function (e) {
  e.preventDefault(); // Предотвращаем стандартную отправку формы

  const form = $("#review-modal-form")[0]; // Получаем DOM-элемент формы
  const formData = new FormData(form); // Создаем объект FormData из формы, чтобы включить текстовые поля

  // Добавляем файлы из FilePond в FormData
  // FilePond.getFiles() возвращает массив объектов FilePondFile
  // file.file содержит нативный объект File
  formData.delete("files[]");

  previewFiles.getFiles().forEach(function (fileItem) {
    formData.append("files[]", fileItem.file);
  });

  // Теперь отправляем FormData с помощью AJAX
  $.ajax({
    url: $(form).attr("action"), // Получаем URL из атрибута action формы
    type: $(form).attr("method") || "POST", // Получаем метод (GET/POST) или по умолчанию POST
    data: formData,
    processData: false, // Обязательно для отправки FormData
    contentType: false, // Обязательно для отправки FormData
    success: function (response) {
      Toastify({
        text: "Отзыв успешно добавлен!",
        gravity: "bottom", // `top` or `bottom`
        position: "right",
        duration: 3000,
      }).showToast();
    },
    error: function (error) {
      console.log(error)
      Toastify({
        text: "При добавлении отзыва произошла ошибка",
        gravity: "bottom", // `top` or `bottom`
        position: "right",
        duration: 3000,
      }).showToast();
    },
  });
});

